import React, { useEffect, useState, useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"

import { sBanner } from "../styled/banner"

import { TravelsContext } from "../contexts/travels-context"

import useSiteMetadata from "../hooks/use-site-metadata"

const Banner = () => {
  const { lang } = useSiteMetadata()

  const {
    state: { tripCount },
  } = useContext(TravelsContext)
  const [banner, setBanner] = useState(null)

  const data = useStaticQuery(graphql`
    query {
      logo: file(name: { eq: "banner-logo" }) {
        publicURL
      }
      bannerHome: file(name: { eq: "banner-home" }) {
        publicURL
      }
      bannerDestinazione: file(name: { eq: "banner-destinazione" }) {
        publicURL
      }
      bannerTema: file(name: { eq: "banner-tema" }) {
        publicURL
      }
    }
  `)

  const { logo } = data

  useEffect(() => {
    if (tripCount === 0) {
      const { bannerHome, bannerDestinazione, bannerTema } = data
      const choice = Math.floor(Math.random() * 3) + 1

      switch (choice) {
        case 2:
          setBanner({
            bg: bannerDestinazione.publicURL,
            bgPosition: "50% 80%",
            text:
              lang === "it"
                ? "La meta dei tuoi sogni a portata di click."
                : "Your dream holiday destination is one click away.",
            link:
              lang === "it"
                ? "https://vivitravels.com/it/destinazioni/?utm_source=viviGuides&utm_medium=Post&utm_campaign=vg_destinazioni&smk=IT010VGSPT191104BBG-"
                : "https://vivitravels.com/en/destinations/?utm_source=viviGuides&utm_medium=Post&utm_campaign=vg_destinazioni&smk=WW010VGSPT191104BBG-",
            textMaxWidth: "220px",
          })
          break
        case 3:
          setBanner({
            bg: bannerTema.publicURL,
            bgPosition: "50% 60%",
            text:
              lang === "it"
                ? "Che tipo di viaggiatore sei? Scegli la tua prossima avventura."
                : "What kind of traveller are you? Choose your next adventure.",
            link:
              lang === "it"
                ? "https://vivitravels.com/it/viaggi-a-tema/?utm_source=viviGuides&utm_medium=Post&utm_campaign=vg_temi&smk=IT010VGSPT191104CBG-"
                : "https://vivitravels.com/en/trip-themes/?utm_source=viviGuides&utm_medium=Post&utm_campaign=vg_temi&smk=WW010VGSPT191104CBG-",
            textMaxWidth: "380px",
          })
          break
        default:
          setBanner({
            bg: bannerHome.publicURL,
            bgPosition: "50% 100%",
            text:
              lang === "it"
                ? "Crea un viaggio da sogno proprio come lo vuoi tu."
                : "Create your dream trip just as you like it.",
            link:
              lang === "it"
                ? "https://vivitravels.com/it/?utm_source=viviGuides&utm_medium=Post&utm_campaign=vg_home&smk=IT010VGSPT191104ABG-"
                : "https://vivitravels.com/en/?utm_source=viviGuides&utm_medium=Post&utm_campaign=vg_home&smk=WW010VGSPT191104ABG-",
            textMaxWidth: "250px",
          })
          break
      }
    } else {
      setBanner(null)
    }
  }, [tripCount, data, lang])

  return banner ? (
    <sBanner.Wrapper
      href={banner.link}
      style={{
        backgroundImage: "url(" + banner.bg + ")",
        backgroundPosition: banner.bgPosition,
      }}
    >
      <img src={logo.publicURL} alt="viviTravels" />
      <p style={{ maxWidth: banner.textMaxWidth }}>{banner.text}</p>
      <span>
        {lang === "it" ? (
          <button title="Scopri di più">SCOPRI</button>
        ) : (
          <button title="Discover more">DISCOVER</button>
        )}
      </span>
    </sBanner.Wrapper>
  ) : null
}

export default Banner
